<template>
  <ShokurekishoJobHistoryCard
    :basic-data="basicData"
    :current-card-id="currentCardId"
    :lead="skillsheetLead"
    :show-omonajiseki="false"
    variant="skillsheet"
  />
</template>

<script setup lang="ts">
import ShokurekishoJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
}>()

const skillsheetLead =
  '今までのプロジェクトの概要を入力しましょう\nプロジェクト名、期間、業務内容、体制、使用したツールやソフトウェアなど具体的に入力しましょう'
</script>
